module.exports = __webpack_public_path__ + "img/welding-2.eee59710.jpg";